module.exports = __webpack_public_path__ + "img/hedder_shelf.8b1612e2.png";